import dayjs, { Dayjs } from 'dayjs'
import weekOfYear from 'dayjs/plugin/weekOfYear'

import { isEmptyString, isNull } from '@app/utils'
import { dateFormat } from '@app/constants'

import { isString } from '@app/typeGuards'

import type { ObjectValuesType } from '@app/types'

dayjs.extend(weekOfYear)

export const toNumbersArray = (value: string, separator = ' '): number[] => {
  const array = isEmptyString(value) ? [] : value.split(separator)

  return array.filter(str => Number(str)).map(Number)
}

export const toStringsArray = (value: string, separator = ' '): string[] =>
  isEmptyString(value) ? [] : value.split(separator).filter(str => !isEmptyString(str))

export const toDayjs = (
  value: string | null,
  format: ObjectValuesType<typeof dateFormat> = dateFormat.YYYY_MM_DD
): Dayjs => {
  return isNull(value) ? dayjs(value) : dayjs(value, format)
}

export const toDayjsByWeek = (week: string | number): Dayjs => {
  const weekNumber = isString(week) ? parseInt(week) : week

  return dayjs().week(weekNumber)
}

export const toBoolean = (value: string): Boolean => !isEmptyString(value)
